import APIService from "./api.service";

class IntervenantService {
    async getIntervenants(pagination = {}) {
        let url = '/intervenants?';
        let page = pagination.page != undefined ? pagination.page : 1;
        let itemsPerPage = pagination.itemsPerPage != undefined ? pagination.itemsPerPage : 20;
        url += '&page=' + page;
        if (itemsPerPage > 0) {
            url += '&itemsPerPage=' + itemsPerPage;
        }
        if (pagination.typeSlug!= undefined){
            url +='&intervenantType.slug='+pagination.typeSlug
        }
        if(pagination.evenementId != undefined){
            url +='&evenement.id='+pagination.evenementId
        }
        url += '&order%5Bpriorite%5D=asc'
        return await APIService.get(url);
    }
    async getIntervervant(intervernantId){
        let url ='/intervenants/'+intervernantId;
        return await  APIService.get(url);
    }
}

export default new IntervenantService();